import Dictionary from './dictionary';
import MinMax from './min-max';
import { RiskProfileRule } from './risk-profiles';
import SavedSections from './saved-sections';
import SectionScoreRangeItem from './section-score-range-item';

type RiskProfileItem = {
  _id: string;
  scoreRange?: MinMax;
  title: Dictionary<string>;
  description: Dictionary<string>;

  // This is currently equivalent to `any` - the rules will be defined inside types/risk-questionnaires.ts
  // to get the full power of Typescript, which also means they cannot be imported in this .d.ts file.
  // Since the risk profiles are used across a bunch of models defined in .d.ts files, we can't bring the
  // full questionnaire definitions over to this new .ts file without refactoring 90% of the app's definitions.
  rules: RiskProfileRule[];

  order?: number;
  sectionScoreRanges?: [SectionScoreRangeItem];

  // The saved sections already exist at the `RiskProfile` level - but the app uses `RiskProfileItem` all
  // around and it's hard to justify the refactor of saving the entire `RiskProfileItem`. For that reason
  // we're duplicating the saved questions on both types - downside is we have an inconsistent type (sometimes they're
  // available, sometimes they aren't), but we can live with that.
  savedSections?: SavedSections;
  questionnaireId?: string;

  isReadOnly?: boolean;
  alternativeModels?: string[];
  key?: string;
  externalData?: {
    externalId?: {
      id: string;
      dataProvider: string;
    };
  };
};

export enum RISK_SCORE_TYPE {
  ORDER = 'ORDER',
}

export type riskProfileUpRisk = {
  riskScore?: number;
  recommendedRiskScore?: number;
  scoreType?: RISK_SCORE_TYPE;
  recommendedRiskProfileId?: string;
};

export type SelectedRiskProfile = RiskProfileItem & {
  upRisk?: riskProfileUpRisk;
};

export default RiskProfileItem;
